import type { AitypesInsight } from '@polaris/api-client'
import { cn } from '@/src/utils/styles'
import TokenImg from '../token-img'

interface InsightCardSubjectProps {
  insight: AitypesInsight
  variant?: 'v1' | 'v2'
}

export const InsightCardSubject = ({
  insight,
  variant = 'v1',
}: InsightCardSubjectProps) => {
  const canShowValidSubjectCTA = {
    none: false,
    kind:
      insight.subjectValue?.type === 'kind' &&
      insight.subjectValue?.displayName &&
      insight.subjectValue?.ticker,
  }
  const subjectComponents = {
    none: <></>,
    kind: (
      <div
        className={cn('flex items-center gap-2', {
          'bg-surface2 rounded-2xl': variant === 'v1',
        })}
      >
        <TokenImg
          src={insight.subjectValue?.logoImgURL}
          width={variant === 'v1' ? 16 : 20}
          height={variant === 'v1' ? 16 : 20}
          className='shrink-0'
          unoptimized
        />
        <span
          className={cn('truncate', {
            'text-primary text-xs': variant === 'v1',
            'text-secondary text-sm': variant === 'v2',
          })}
        >
          {insight.subjectValue?.ticker}
        </span>
      </div>
    ),
  }

  return canShowValidSubjectCTA[insight.subject]
    ? subjectComponents[insight.subject]
    : null
}
